import { isNativeMode, nativeGatewayBaseUrl } from "../native/nativeMode";

/**
 * Pantallas native con marco propio (barra superior + columna + pie legal sobre
 * el mismo fondo): el Layout global no pinta en ellas su navbar ni su footer.
 * Solo native, de momento: el resto de mercados sigue con el Layout de siempre
 * hasta validarlo.
 */
export const dashboardHasOwnShell = (): boolean => isNativeMode();

export const isDashboardPath = (pathname: string): boolean =>
  pathname.startsWith("/dashboard");

/** Presupuesto del funnel (calculator/4), mismo marco que el Dashboard. */
export const isNativeQuotePath = (pathname: string): boolean =>
  /^\/calculator\/4\/?$/.test(pathname);

/**
 * Confirmación de renovación con el enlace native (`?t=`, F3.4 P4): llega sin
 * sesión ni `?native=1`, así que el marco no depende del modo native sino de que
 * haya gateway native y token en el enlace.
 */
export const isNativeRenewalConfirmation = (pathname: string, search: string): boolean =>
  /^\/renewal-confirmation\/?$/.test(pathname) &&
  "" !== nativeGatewayBaseUrl() &&
  new URLSearchParams(search).has("t");

export const pageHasOwnShell = (pathname: string, search = ""): boolean =>
  (isNativeMode() && (isDashboardPath(pathname) || isNativeQuotePath(pathname))) ||
  isNativeRenewalConfirmation(pathname, search);
